// This file is auto-generated by scripts/generate-icons.js
// Do not edit manually

import BigCommerceSvg from '../../assets/icons/BigCommerce.svg?raw';
import EtsySvg from '../../assets/icons/Etsy.svg?raw';
import SalesforceSvg from '../../assets/icons/Salesforce.svg?raw';
import SnapchatSvg from '../../assets/icons/Snapchat.svg?raw';
import TikTokSvg from '../../assets/icons/TikTok.svg?raw';
import WalmartSvg from '../../assets/icons/Walmart.svg?raw';
import WooCommerceSvg from '../../assets/icons/WooCommerce.svg?raw';
import agentSvg from '../../assets/icons/agent.svg?raw';
import aiSvg from '../../assets/icons/ai.svg?raw';
import aliexpressSvg from '../../assets/icons/aliexpress.svg?raw';
import amazonSvg from '../../assets/icons/amazon.svg?raw';
import arrow_fatSvg from '../../assets/icons/arrow_fat.svg?raw';
import artifactSvg from '../../assets/icons/artifact.svg?raw';
import attachSvg from '../../assets/icons/attach.svg?raw';
import billingSvg from '../../assets/icons/billing.svg?raw';
import bingSvg from '../../assets/icons/bing.svg?raw';
import brandSvg from '../../assets/icons/brand.svg?raw';
import chatButtonSvg from '../../assets/icons/chatButton.svg?raw';
import checkSvg from '../../assets/icons/check.svg?raw';
import codeSvg from '../../assets/icons/code.svg?raw';
import collapseSvg from '../../assets/icons/collapse.svg?raw';
import collapse_chatSvg from '../../assets/icons/collapse_chat.svg?raw';
import completeSvg from '../../assets/icons/complete.svg?raw';
import connectSvg from '../../assets/icons/connect.svg?raw';
import create_dashboardSvg from '../../assets/icons/create_dashboard.svg?raw';
import credit_colorSvg from '../../assets/icons/credit_color.svg?raw';
import criteoSvg from '../../assets/icons/criteo.svg?raw';
import cropSvg from '../../assets/icons/crop.svg?raw';
import cutSvg from '../../assets/icons/cut.svg?raw';
import dashboardSvg from '../../assets/icons/dashboard.svg?raw';
import databaseSvg from '../../assets/icons/database.svg?raw';
import defaultAvatarSvg from '../../assets/icons/defaultAvatar.svg?raw';
import deleteSvg from '../../assets/icons/delete.svg?raw';
import desktopSvg from '../../assets/icons/desktop.svg?raw';
import detailsSvg from '../../assets/icons/details.svg?raw';
import downloadSvg from '../../assets/icons/download.svg?raw';
import ebaySvg from '../../assets/icons/ebay.svg?raw';
import editSvg from '../../assets/icons/edit.svg?raw';
import edit_productSvg from '../../assets/icons/edit_product.svg?raw';
import excelSvg from '../../assets/icons/excel.svg?raw';
import expandUpSvg from '../../assets/icons/expandUp.svg?raw';
import facebook_adsSvg from '../../assets/icons/facebook_ads.svg?raw';
import fileSvg from '../../assets/icons/file.svg?raw';
import file_colorSvg from '../../assets/icons/file_color.svg?raw';
import filterSvg from '../../assets/icons/filter.svg?raw';
import find_productSvg from '../../assets/icons/find_product.svg?raw';
import findingSvg from '../../assets/icons/finding.svg?raw';
import fullscreenSvg from '../../assets/icons/fullscreen.svg?raw';
import generate_pageSvg from '../../assets/icons/generate_page.svg?raw';
import googleSvg from '../../assets/icons/google.svg?raw';
import historySvg from '../../assets/icons/history.svg?raw';
import homeSvg from '../../assets/icons/home.svg?raw';
import image_uploadSvg from '../../assets/icons/image-upload.svg?raw';
import infoSvg from '../../assets/icons/info.svg?raw';
import layoutSvg from '../../assets/icons/layout.svg?raw';
import loadingSvg from '../../assets/icons/loading.svg?raw';
import lockSvg from '../../assets/icons/lock.svg?raw';
import logoSvg from '../../assets/icons/logo.svg?raw';
import logo_brandSvg from '../../assets/icons/logo_brand.svg?raw';
import logo_miniSvg from '../../assets/icons/logo_mini.svg?raw';
import logoutSvg from '../../assets/icons/logout.svg?raw';
import magentoSvg from '../../assets/icons/magento.svg?raw';
import magicSvg from '../../assets/icons/magic.svg?raw';
import matchSvg from '../../assets/icons/match.svg?raw';
import meta_adsSvg from '../../assets/icons/meta-ads.svg?raw';
import minimizeSvg from '../../assets/icons/minimize.svg?raw';
import mobileSvg from '../../assets/icons/mobile.svg?raw';
import new_chatSvg from '../../assets/icons/new_chat.svg?raw';
import ordersSvg from '../../assets/icons/orders.svg?raw';
import pdfSvg from '../../assets/icons/pdf.svg?raw';
import pinterestSvg from '../../assets/icons/pinterest.svg?raw';
import planSvg from '../../assets/icons/plan.svg?raw';
import plusSvg from '../../assets/icons/plus.svg?raw';
import plus_outlineSvg from '../../assets/icons/plus_outline.svg?raw';
import pptSvg from '../../assets/icons/ppt.svg?raw';
import previewSvg from '../../assets/icons/preview.svg?raw';
import product_centerSvg from '../../assets/icons/product_center.svg?raw';
import product_searchSvg from '../../assets/icons/product_search.svg?raw';
import product_sourcingSvg from '../../assets/icons/product_sourcing.svg?raw';
import profileSvg from '../../assets/icons/profile.svg?raw';
import projectSvg from '../../assets/icons/project.svg?raw';
import publishSvg from '../../assets/icons/publish.svg?raw';
import pulseSvg from '../../assets/icons/pulse.svg?raw';
import searchSvg from '../../assets/icons/search.svg?raw';
import sendSvg from '../../assets/icons/send.svg?raw';
import shellSvg from '../../assets/icons/shell.svg?raw';
import shopifySvg from '../../assets/icons/shopify.svg?raw';
import similarwebSvg from '../../assets/icons/similarweb.svg?raw';
import slackSvg from '../../assets/icons/slack.svg?raw';
import social_searchSvg from '../../assets/icons/social_search.svg?raw';
import sparklesSvg from '../../assets/icons/sparkles.svg?raw';
import starSvg from '../../assets/icons/star.svg?raw';
import storeSvg from '../../assets/icons/store.svg?raw';
import textSvg from '../../assets/icons/text.svg?raw';
import thinkingSvg from '../../assets/icons/thinking.svg?raw';
import usersSvg from '../../assets/icons/users.svg?raw';
import wordSvg from '../../assets/icons/word.svg?raw';

// Map of all icons
export const ALL_ICONS: Record<string, string> = {
  'BigCommerce': BigCommerceSvg,
  'Etsy': EtsySvg,
  'Salesforce': SalesforceSvg,
  'Snapchat': SnapchatSvg,
  'TikTok': TikTokSvg,
  'Walmart': WalmartSvg,
  'WooCommerce': WooCommerceSvg,
  'agent': agentSvg,
  'ai': aiSvg,
  'aliexpress': aliexpressSvg,
  'amazon': amazonSvg,
  'arrow_fat': arrow_fatSvg,
  'artifact': artifactSvg,
  'attach': attachSvg,
  'billing': billingSvg,
  'bing': bingSvg,
  'brand': brandSvg,
  'chatButton': chatButtonSvg,
  'check': checkSvg,
  'code': codeSvg,
  'collapse': collapseSvg,
  'collapse_chat': collapse_chatSvg,
  'complete': completeSvg,
  'connect': connectSvg,
  'create_dashboard': create_dashboardSvg,
  'credit_color': credit_colorSvg,
  'criteo': criteoSvg,
  'crop': cropSvg,
  'cut': cutSvg,
  'dashboard': dashboardSvg,
  'database': databaseSvg,
  'defaultAvatar': defaultAvatarSvg,
  'delete': deleteSvg,
  'desktop': desktopSvg,
  'details': detailsSvg,
  'download': downloadSvg,
  'ebay': ebaySvg,
  'edit': editSvg,
  'edit_product': edit_productSvg,
  'excel': excelSvg,
  'expandUp': expandUpSvg,
  'facebook_ads': facebook_adsSvg,
  'file': fileSvg,
  'file_color': file_colorSvg,
  'filter': filterSvg,
  'find_product': find_productSvg,
  'finding': findingSvg,
  'fullscreen': fullscreenSvg,
  'generate_page': generate_pageSvg,
  'google': googleSvg,
  'history': historySvg,
  'home': homeSvg,
  'image-upload': image_uploadSvg,
  'info': infoSvg,
  'layout': layoutSvg,
  'loading': loadingSvg,
  'lock': lockSvg,
  'logo': logoSvg,
  'logo_brand': logo_brandSvg,
  'logo_mini': logo_miniSvg,
  'logout': logoutSvg,
  'magento': magentoSvg,
  'magic': magicSvg,
  'match': matchSvg,
  'meta-ads': meta_adsSvg,
  'minimize': minimizeSvg,
  'mobile': mobileSvg,
  'new_chat': new_chatSvg,
  'orders': ordersSvg,
  'pdf': pdfSvg,
  'pinterest': pinterestSvg,
  'plan': planSvg,
  'plus': plusSvg,
  'plus_outline': plus_outlineSvg,
  'ppt': pptSvg,
  'preview': previewSvg,
  'product_center': product_centerSvg,
  'product_search': product_searchSvg,
  'product_sourcing': product_sourcingSvg,
  'profile': profileSvg,
  'project': projectSvg,
  'publish': publishSvg,
  'pulse': pulseSvg,
  'search': searchSvg,
  'send': sendSvg,
  'shell': shellSvg,
  'shopify': shopifySvg,
  'similarweb': similarwebSvg,
  'slack': slackSvg,
  'social_search': social_searchSvg,
  'sparkles': sparklesSvg,
  'star': starSvg,
  'store': storeSvg,
  'text': textSvg,
  'thinking': thinkingSvg,
  'users': usersSvg,
  'word': wordSvg,
};

// List of all icon names
export const ALL_ICON_NAMES = Object.keys(ALL_ICONS);

// Check if an icon exists
export const isValidIcon = (name: string): boolean => {
  return name in ALL_ICONS;
};

// Get icon content
export const getIcon = (name: string): string | null => {
  return ALL_ICONS[name] || null;
};
